import { render, staticRenderFns } from "./client-unit-form.vue?vue&type=template&id=71784192&scoped=true&lang=pug&"
import script from "./client-unit-form.vue?vue&type=script&lang=ts&"
export * from "./client-unit-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71784192",
  null
  
)

export default component.exports